import React from 'react'
import moment from 'moment'
import { chartColors } from 'components/charts/colors'
import RespondentsPercentageBarChart from './RespondentsPercentageBarChart'

const TestResults = () => {
  const previousWeekStart = moment().subtract(14, 'days').startOf('day')
  const mostRecentWeekStart = moment().subtract(7, 'days').startOf('day')
  const today = moment().startOf('day')

  return (
    <RespondentsPercentageBarChart
      questionSlug="test-results"
      title="Test Results"
      leftChartTitle="Previous Week"
      leftChartStart={previousWeekStart}
      leftChartEnd={mostRecentWeekStart}
      rightChartTitle="Most Recent Week"
      rightChartStart={mostRecentWeekStart}
      rightChartEnd={today}
      chartColors={{
        error: chartColors.bad,
        'yes-positive': chartColors.bad,
        'yes-negative': chartColors.good,
        'yes-pending': chartColors.lessGood,
        'no-test': chartColors.neutral,
      }}
      chartLabels={{
        'yes-positive': 'Positive (virus present)',
        'yes-negative': 'Negative (no virus)',
        'yes-pending': 'Result pending',
        'no-test': 'Untested',
      }}
      bgClass="bg-blvl-gradient-lightblue"
      titleClass="text-blue"
    />
  )
}

export default TestResults
